/**
 * [PIN-ZARZAD, decyzja właściciela 2026-09-27] „pin zostaw tylko dla admina 5 cyfry to jest ok".
 *
 * Jedno miejsce długości PIN-u administratora po stronie ekranu. NOWY PIN ma zawsze 5 cyfr; PIN ustawiony przed zmianą
 * reguły (4 cyfry) działa do czasu wymiany — serwer mówi, który podaje dane konto (`dlugoscPinu` w
 * `/health/admin-pin-status`), a po jego podaniu (`wymagaZmiany`) ekran proponuje ustawienie nowego.
 * Lustro serwera: `DogSoft.WebApi/Helpers/PinAdministratora.cs`.
 */
export const DLUGOSC_PINU = 5;
export const DLUGOSC_DAWNEGO_PINU = 4;

/** Ile pól pokazać: 4 wyłącznie wtedy, gdy serwer wprost mówi, że konto ma PIN sprzed zmiany. */
export const dlugoscZOdpowiedzi = (dane) => (dane?.dlugoscPinu === DLUGOSC_DAWNEGO_PINU ? DLUGOSC_DAWNEGO_PINU : DLUGOSC_PINU);

/** Czy to poprawny NOWY PIN — dokładnie 5 cyfr. */
export const poprawnyNowyPin = (pin) => typeof pin === "string" && /^[0-9]{5}$/.test(pin);
